/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React from 'react'

import { View } from '@components/atoms'
import { SeasonListItem } from '@components/molecules'
import { SeasonType } from '@schemas'
import { boShared } from '@components/systems/backoffice/backoffice.tokens'

interface SeasonListProps {
	seasons: SeasonType[]
	selectedSeasonId: string
	onSeasonClick: (season: SeasonType) => void
	/** 대기열에 넣기. 날짜 역전 검사는 호출부(Season.page)가 한다. */
	onAddToQueue: (season: SeasonType) => void
}

export const SeasonList = (props: SeasonListProps) => {
	const { seasons, selectedSeasonId, onSeasonClick, onAddToQueue } = props

	return (
		<View css={style}>
			<View className="seasonListView">
				{seasons && seasons.length > 0 ? (
					seasons.map(season => {
						const isSelected = season.id === selectedSeasonId
						return (
							<SeasonListItem
								key={season.id}
								{...season}
								isSelected={isSelected}
								onClick={() => onSeasonClick(season)}
								onAddToQueue={() => onAddToQueue(season)}
							/>
						)
					})
				) : (
					<p className="boEmpty">No seasons available.</p>
				)}
			</View>
		</View>
	)
}

const style = css({
	...boShared,
	overflow: 'auto',
	height: '100%',
	width: '100%',
	padding: 0,
})
